import volumeOff from 'assets/games/theme-two/icons/volumeOff.svg';
import volumeOn from 'assets/games/theme-two/icons/volumeOn.svg';

import styles from './video.module.css';

export default function Video({ bgMusicMuted }) {
  return (
    <div className={styles.SlotMachineVideoWrapper}>
      <div className={styles.SlotMachineVideoContainer}>
        <div
          className={styles.SlotMachineVideoMuteButton}
          id="slotGameVideoVolumeControlButton"
        >
          <img
            src={bgMusicMuted ? volumeOff : volumeOn}
            id="slotGameVideoVolumeControl"
            alt="volume control"
            className="slot-game-video-mute"
          />
        </div>
        <video
          className={styles.SlogMachineVideo}
          id="slotGameVideo"
          autoPlay
          muted
        ></video>
      </div>
    </div>
  );
}
